// FE:C1 — help entries for the OAuth consent page (namespace `consent`, CONTRACTS §6).
// Every claim names the code that makes it true.
import type { HelpEntry } from '../types'

export const HELP: readonly HelpEntry[] = [
  {
    id: 'consent.what_connecting_does',
    title: 'What connecting an AI app does',
    body: 'Connecting lets the AI app call FuseGrid on your behalf, as you. It can only use the permissions you check here, and FuseGrid rechecks your current access to each company on every call. The app never receives your FuseGrid password.',
    verified_by: [
      'fusegrid_v2/server/src/platform/oauth.rs:1154',
      'fusegrid_v2/server/src/platform/authority.rs:338',
    ],
  },
  {
    id: 'consent.all_companies',
    title: 'All companies, including ones added later',
    body: 'Choosing "All companies I can access" follows your FuseGrid access over time. When you are given access to a new company, the app can use it too; when your access to a company is removed, the app loses it on its next call. Choose "Only selected companies" to limit the app to a fixed list.',
    verified_by: [
      'fusegrid_v2/server/src/platform/authority.rs:287',
      'fusegrid_v2/server/src/platform/authority.rs:338',
    ],
  },
  {
    id: 'consent.scopes',
    title: 'Permissions',
    body: 'Read lets the app view financials and reports and is always included. Make changes lets it update goals, plans and workbook content. Act in your open Excel workbook lets it work inside the FuseGrid Excel add-in. Your role on each company still applies: a viewer cannot make changes even if the app has that permission.',
    verified_by: [
      'fusegrid_v2/server/src/platform/capabilities.rs:266',
      'fusegrid_v2/server/src/platform/capabilities.rs:277',
    ],
  },
  {
    id: 'consent.local_apps',
    title: 'Local apps on this computer',
    body: 'Apps that run on your own computer (for example a desktop or command-line AI tool) connect through a local address and cannot be verified by FuseGrid. They are labeled unverified and start with read-only access. Only approve them if you started the connection yourself.',
    verified_by: [
      'fusegrid_v2/server/src/platform/oauth.rs:56',
      'fusegrid_v2/server/src/platform/oauth.rs:914',
    ],
  },
  {
    id: 'consent.revoke',
    title: 'Disconnecting an app',
    body: 'You can disconnect the app or narrow its permissions on the Connect page at any time. Access also ends automatically when your access to a company is removed, and a firm administrator can revoke a connection for you.',
    verified_by: [
      'fusegrid_v2/server/src/platform/connections.rs:172',
      'fusegrid_v2/server/src/platform/connections.rs:243',
    ],
  },
]
